import { z } from "zod";

export const RepresentanteLegalSchema = z.object({
  tipoDocumento: z.enum(["CC", "CE", "PAS"], {
    required_error: "El tipo de documento es obligatorio",
  }),
  numeroDocumento: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(3, "El número de documento debe tener al menos 3 caracteres")
    .nonempty("Campo obligatorio"),
  nombres: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(2, "Los nombres son obligatorios")
    .nonempty("Campo obligatorio"),
  apellidos: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(2, "Los apellidos son obligatorios")
    .nonempty("Campo obligatorio"),
  pais: z
    .string({
      required_error: "El pais es obligatorio",
    })
    .min(1, "El pais es obligatorio"),
  departamento: z.string().optional(),
  ciudad: z.string().optional(),
  fechaNacimiento: z
    .string({ required_error: "Ingrese la fecha de nacimiento" })
    .min(1, "Ingrese la fecha de nacimiento")
    .nonempty("Campo obligatorio"),
    // .refine((val) => !isNaN(Date.parse(val)), {
    //   message: "Debe ser una fecha válida",
    // }),
  direccion: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(3, "La dirección es obligatoria")
    .nonempty("Campo obligatorio"),
  telefono: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(7, "El teléfono debe tener mínimo 7 dígitos")
    .regex(/^[0-9]+$/, "El teléfono solo debe contener números"),
  ocupacion: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(2, "La ocupación u oficio es obligatoria")
    .nonempty("Campo obligatorio"),
});

export type RepresentanteLegalDto = z.infer<typeof RepresentanteLegalSchema>;
